<template>
  <div>
    <Toast />
    <div class="p-mb-4" v-if="menuStore.currentMenuItem.to !== '/rendez-vous-confirme' && menuStore.currentMenuItem.to !== '/devis-confirme'">
      <Steps :model="menuStore.currentMenu" />
    </div>
    <div>
      <router-view v-slot="{Component}">
        <keep-alive>
          <component :is="Component" @prevPage="prevPage($event)" @nextPage="nextPage($event)"/>
        </keep-alive>
      </router-view>
    </div>
  </div>
</template>

<script>
import Steps from "primevue/steps";
import { useToast } from "primevue/usetoast";
import { useMenuStore } from "./stores/menu";
import { useRouter } from 'vue-router'

export default {
  name: 'App',
  components: {Steps},
  setup () {
    const toast = useToast()
    const router = useRouter()
    const menuStore = useMenuStore();

    if ((menuStore.countItemsInMenu() === 0) && !window.location.href.endsWith("/intervention")) {
      menuStore.goToHome()
      router.push("/intervention")
    }

    const nextPage = (event) => {
      try {
        menuStore.addMenuItem(event)
        router.push(event.to)
        window.scrollTo(0, 0);
      } catch (e) {
        menuStore.goToHome()
        router.push("/intervention")
        window.scrollTo(0, 0);
      }
    };
    const prevPage = (event) => {
      try {
        menuStore.goToParentMenuItem(event.parent)
        menuStore.removeLastMenuItem()
        router.push(menuStore.currentMenuItem.to)
        window.scrollTo(0, 0);
      } catch (e) {
        menuStore.goToHome()
        router.push("/intervention")
        window.scrollTo(0, 0);
      }
    };

    return {
      toast,
      menuStore,
      nextPage,
      prevPage
    }
  },
}
</script>

<style></style>
